<script>
  export let item;

  const parseTime = (t) => { const [h, m] = t.split(":").map(Number); return h * 60 + m; };
  const startMinutes = parseTime(item.startTime);
  const endMinutes = parseTime(item.endTime);
  const offsetMinutes = startMinutes - 8 * 60;
  const durationMinutes = endMinutes - startMinutes;

  const timeblockStyle = `position: absolute; top: ${offsetMinutes * 3}px; height: ${durationMinutes * 3}px;`;
</script>

<div class="not-prose right-[2%] w-[46%] flex flex-col gap-1 border border-solid rounded-md border-gray-400/50 bg-im-brown-100 p-3 drop-shadow-md" style={timeblockStyle}>
  <span class="text-sm font-bold ">Starvortrag</span>
  <div class="flex bg-im-signal border border-solid rounded-md -mx-3 px-3">
    <span class="text-sm text-white whitespace-pre-wrap">
      {item.referent1name}
    </span>
  </div>
  <span class="text-xs">{item.startTime} - {item.endTime}</span>
  <span class="text-xs">Großer Saal</span>
</div>